import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import ExampleCard from '../../components/itineraryExamples/ExampleCard';
import { getItineraryExamplesForIsland } from '../../data/itineraryExamples';
import { getRuntimeSiteContext } from '../../lib/siteContext';

const ItineraryExamples = () => {
  const { island, islandConfig } = React.useMemo(() => getRuntimeSiteContext(), []);
  const itineraryExamples = React.useMemo(
    () => getItineraryExamplesForIsland(island),
    [island],
  );
  const islandName = islandConfig?.title || islandConfig?.shortTitle || 'Hawaiʻi';

  return (
    <div className="text-white pb-24">
      <Helmet>
        <title>Itinerary Examples | Alaka‘i Aloha</title>
        <meta
          name="description"
          content={`Explore personalized ${islandName} itineraries crafted by Alaka‘i Aloha. See how we tailor each trip, then start your own custom plan.`}
        />
      </Helmet>

      <section className="pt-0 sm:pt-2 pb-12 space-y-6 text-center">
        <h1 className="text-4xl sm:text-5xl font-semibold leading-tight max-w-3xl mx-auto mt-0">
          See what a truly custom itinerary looks like
        </h1>
        <p className="text-white/80 text-lg leading-relaxed max-w-3xl mx-auto">
          Every itinerary you see here belongs to a traveler who trusted Alaka‘i Aloha with their trip and generously agreed to share their interview and itinerary. Browse the examples to get a feel for what we deliver—then start your interview so we can craft one just for you.
        </p>
      </section>

      <section id="examples-grid" className="space-y-8">
        <div className="space-y-8">
          {itineraryExamples.map((example, index) => (
            <ExampleCard key={example.id} example={example} orientation={index % 2 === 1 ? 'reverse' : 'default'} />
          ))}
        </div>
      </section>

      <section className="pt-16 text-center space-y-4">
        <h2 className="text-3xl sm:text-4xl font-semibold text-white leading-tight">Ready to see your own version?</h2>
        <Link to="/interview" className="btn-primary-cta w-full sm:w-64 mx-auto">
          Start Interview
        </Link>
      </section>
    </div>
  );
};

export default ItineraryExamples;
